import { render } from "./ColumnView.vue?vue&type=template&id=dae0cf1e&ts=true"
import script from "./ColumnView.vue?vue&type=script&lang=ts"
export * from "./ColumnView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__